import { useAuth0 } from '@auth0/auth0-react';
import { useAuthUser } from '@states/user.atom';

export function useLogout(returnToPath: string = '/') {
  const { logout } = useAuth0();
  const { clearActiveUser } = useAuthUser();

  const handleLogout = () => {
    clearActiveUser();
    logout({
      logoutParams: {
        returnTo: window.location.origin + returnToPath,
      },
    });
  };

  return handleLogout;
}
